import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPedroBubble = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.79102 14.9762H2.94033L4.95607 16.9919L9.98559 22.0214C11.3722 23.5329 13.4489 24.2392 15.6455 24.2726C17.8638 24.3063 20.307 23.662 22.5808 22.3492C25.0815 20.9053 26.9888 18.8768 28.0209 16.711C29.0503 14.5508 29.2509 12.1341 28.0791 10.1045C26.9073 8.07492 24.7141 7.04031 22.3286 6.85167C19.9369 6.66253 17.2265 7.30004 14.7257 8.74387C12.01 10.3118 9.97827 12.581 9.02583 14.9762H5.79102Z",
		fill: "#4EA4BD",
		stroke: "#06748D",
		strokeWidth: 2.36159
	})
});
const ForwardRef = forwardRef(SvgPedroBubble);
export default ForwardRef;
